interface Props {
    tagName: string
    percentNumber: string
    prop: string
    prop1: string
    className?: string
    frameClassName?: string
    frameClassNameOverride?: string
    divClassName?: string
}

export const Food = ({
    tagName = "食材新鮮度",
    percentNumber = "72",
    prop = "正向評論",
    prop1 = "%",
    className,
    frameClassName,
    frameClassNameOverride,
    divClassName,
}: Props): JSX.Element => {
    return (
        <div
            className={`relative w-[186px] h-40 flex flex-col gap-[15.6px] bg-[#e8d080] rounded-[30px] overflow-hidden border-[4.55px] border-solid border-white ${className || ''}`}
        >
            <div
                className={`flex w-[170px] h-[30px] relative mt-9 items-center justify-center gap-2.5 px-0 py-0 bg-white rounded-r-[30px] ${frameClassName || ''}`}
            >
                <div className="text-xl tracking-[4.00px] whitespace-nowrap relative flex items-center justify-center w-fit [font-family:'Noto_Sans_TC',Helvetica] font-bold text-[#33363f] leading-[normal]">
                    {tagName}
                </div>
            </div>

            <div
                className={`flex ml-0 w-[186px] h-[35px] relative items-end justify-between px-[17px] py-0 ${frameClassNameOverride || ''}`}
            >
                <div className="relative flex items-center justify-center w-14 h-8 [font-family:'Noto_Sans_TC',Helvetica] font-bold text-[#33363f] text-[40px] tracking-[4.00px] leading-[normal] whitespace-nowrap">
                    {percentNumber}
                </div>

                <div className="relative flex items-end justify-center w-[18px] h-[31px] [font-family:'Noto_Sans_TC',Helvetica] font-bold text-[#33363f] text-xl tracking-[2.00px] leading-[normal]">
                    {prop1}
                </div>

                <div
                    className={`text-sm tracking-[1.40px] relative flex items-center justify-center w-fit [font-family:'Noto_Sans_TC',Helvetica] font-bold text-[#33363f] leading-[normal] ${divClassName || ''}`}
                >
                    {prop}
                </div>
            </div>
        </div>
    )
}
